






































import type { AuthenticationStep } from '@getaccept/lib-shared/src/authentication/types/authentication-step';
import { AuthenticationStepType } from '@getaccept/lib-shared/src/authentication/types/enums/authentication-step-type';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  props: {
    authStep: { type: Object as PropType<AuthenticationStep>, required: true },
    submittingResponse: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const value = ref('');

    const handleAnswer = () => {
      emit('answer', { type: AuthenticationStepType.VerifyQna, value: value.value });
    };
    const qnaLabel = computed(() => props.authStep.data.question || t('password'));

    return {
      handleAnswer,
      qnaLabel,
      value,
    };
  },
});
